<template>
  <div id="app">
    <nav-bar/>
    <transition name="page" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mdbContainer } from 'mdbvue';
import NavBar from './components/NavBar';

export default {
  name: 'PentagonApp',
  components: {
    NavBar,
    mdbContainer
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,400i,700&display=swap');

#app {
  font-family: 'Montserrat', 'Avenir', Arial, sans-serif;
}

.top-nav-collapse {
  background-color: #C2192B !important;
}

.pentagon-gold {
  color: #EFD310;
}
.pentagon-green {
  color: #073E02;
}

.pentagon-red {
  color: #901A2B;
}

main {
  position: relative;
  top: 85px;
}

h1, h5 {
  text-transform: uppercase;
}

h5 {
  letter-spacing: 3px;
}

.page-enter-active, .page-leave-active {
  transition: opacity 1s, transform 800ms;
}
.page-enter, .page-leave-to {
  opacity: 0;
  transform: translateY(30%);
}
</style>
